export default __webpack_public_path__ + "static/media/Class-9-State-Kanada.1e399d8f.pdf";